import React from "react";

function ConfirmationDelete({
  productId,
  productName,
  onSetError,
  onSetProducts,
  onSetIsModal,
  onDeleteProduct,
  isDeletingProduct,
}) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-10 p-12 flex flex-col items-center justify-center z-50">
      <div className="!bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4 text-red-600">
          Delete Address
        </h2>
        <p className="mb-6">
          Are you sure you want to delete <strong>{productName}</strong>?
        </p>
        <div className="flex justify-end space-x-4">
          <button
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
            onClick={() => onSetIsModal(false)}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            onClick={() => onDeleteProduct(productId)}
          >
            {isDeletingProduct ? "Loading..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationDelete;
